import React from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { has } from 'lodash'
import legolasApi from '../../api/legolas'
import { List, Box, Typography, Input, Select, MenuItem, Button, Divider, Menu, FormControl, FormGroup, Checkbox, Radio, FormControlLabel, RadioGroup, 
  TableContainer, Table, TableHead, TableBody, TableRow, Paper, Modal, Pagination } from '@mui/material'
import globalStyles from '../../utils/globalStyles'
import globalConfig from '../../utils/globalConfig'
import { StyledTableCell, StyledTableRow } from '../common/StyledTableElements'
import EditIcon from '@mui/icons-material/Edit';
import SearchIcon from '@mui/icons-material/Search';
import ChannelDropDown from '../common/ChannelDropDown'

function ReturnsList() {
  const [listData, setListData] = React.useState([]);
  const [dataCount, setDataCount] = React.useState(0);
  const [currentPage, setCurrentPage] = React.useState(1);
  const [selectedHeaders, setSelectedHeaders] = React.useState([
    {id: 'rma_id', label: 'RMA ID'}, {id: 'rma_created_date', label: 'Request Date'}, {id: 'order_id', label: 'Order #'},
    {id: 'return_type', label: 'Return Type'}, {id: 'order_created_date', label: 'Order Date'},
    {id: 'customer_name', label: 'Customer Name'}, {id: 'manager_name', label: 'Manager'},
    {id: 'status', label: 'Status'},{id: 'channel', label: 'Channel'}
  ])
  const navigate = useNavigate()
  const [searchString, setSearchstring] = React.useState('')

  const allTableHeaders = [
    {id: 'orderId', label: 'ID'}, {id: 'createdAt', label: 'Purchase Date'},
    {id: 'grandTotal', label: 'Grand Total'}, {id: 'status', label: 'Status'},, 
    {id: 'shipment_status', label: 'Shipment Status' }
  ]
  const [channelData, setChannelData] = React.useState([]);
  const [channelFilterArray, setChannelFilterArray] = React.useState([]);
  const localStorageUser = localStorage.getItem('user');
  const user = JSON.parse(localStorageUser);
  const userChannels = Array.isArray(user?.channel) ? user.channel.map(String) : [];

  const buildReturnListPayload = (page = 1, searchStr = '', channelOverride = null) => {
  const offset = (page - 1) * 50;

  const channelPayload = Array.isArray(channelOverride) ? channelOverride : (channelFilterArray?.length > 0 ? channelFilterArray : userChannels);
  const payload = { offset, limit: 50, channel: channelPayload, };
  if (searchStr?.trim()) { payload.orderId = searchStr.trim(); }
  return payload;
};

React.useEffect(() => {
  getChannel();
  const payload = buildReturnListPayload(1);
  axios.post(`${legolasApi.url}/admin/rma/order/list`, payload)
    .then(res => {
      if (res.data.success) {
        setListData(res.data.rmaOrders);
        setDataCount(res.data.count);
      }
    })
    .catch((error) => console.log('Error fetching return orders:', error));
}, []);

  const getChannel=()=>{
    axios.get(`${legolasApi.url}/admin/channel/list`)
    .then((res) => {
      console.log('order res: ', res.data.data);
      //setChannelData(res.data.data);
      const allChannels = res.data.data;
        const filteredChannels = allChannels.filter(ch => userChannels.includes(ch._id));
        setChannelData(filteredChannels);
    })
    .catch((error) => console.log('Error in getting orders: ', error));
  }
  
  function EditReturnHandler(rma) {
    const link = `/edit-return/${rma.entity_id}`
    navigate(link, { state: { data: rma }})
  }

  const handleSearch = () => {
    const searchQuery = { "orderId" : searchString,
       channel: (channelFilterArray && channelFilterArray.length > 0)
      ? channelFilterArray
      : (userChannels.length > 0 ? userChannels : null)
     }
    axios.post(`${legolasApi.url}/admin/rma/order/list`, searchQuery).then((res) => {
      console.log('admin/Returnlist res: ', res)
      const data = res.data.rmaOrders, count = res.data.count
      setListData(data)
      setDataCount(count)
    }).catch((error) => console.log('Error in getting invoices: ', error))
  }
  const handleFilter = (field, value) => {
    console.log("channelFilterArray value",value)
    let newChannelFilterArray = channelFilterArray;;
     if (field === 'channel') {
      newChannelFilterArray = Array.isArray(value) && value.length > 0
      ? value
      : userChannels;
      if (value === null) {
        newChannelFilterArray = null ;
    } else {
        newChannelFilterArray = value;
    }
    setChannelFilterArray(newChannelFilterArray);
    }
    const filterQuery = {
      channel: newChannelFilterArray  
    };

    axios.post(`${legolasApi.url}/admin/rma/order/list`, filterQuery).then((res) => {
      setListData(res.data.rmaOrders);
      setDataCount(res.data.count)
      })
      .catch((error) => console.log('Error in getting orders: ', error))
  }

  const handlePagination = (event, value) => {
    const paginationPayload = {
     // "channel":  channelFilterArray == null||channelFilterArray.length === 0 ? null : channelFilterArray
      channel: (channelFilterArray && channelFilterArray.length > 0)
      ? channelFilterArray
      : (userChannels.length > 0 ? userChannels : null)
    };
  
    axios.post(`${legolasApi.url}/admin/rma/order/list?offset=${value-1}`,paginationPayload).then((res) => {
      setCurrentPage(value);
      setListData(res.data.rmaOrders);
      setDataCount(res.data.count)
    })
  }

  return (
    <List actions={null}>
      <Box sx={globalStyles.headerWrapperBox}>
        <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
          <Typography variant='h4'>Manage Returns</Typography>
          <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
            {dataCount} record(s) found
          </Typography>
        </Box>
      </Box>

      <Box sx={{ 
        width: '100%', 
        display: 'flex', 
        margin: '0px 30px 10px',
        '& .MuiInput-input': {
          width: '300px !important',
          padding: '5px 10px !important'
        },
        '& .MuiSvgIcon-root': {
          paddingRight: '10px'
        } 
      }}>
        <Input
          type='search' 
          sx={{ border: '1px solid #2b3f7a', borderRadius: '20px',height:'40px', marginTop:'20px',marginRight:'5%' }} 
          endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} onClick={() => handleSearch()}/>} 
          placeholder='Seach by Order ID'
          onChange={(e) => setSearchstring(e.target.value)}
        />
       { userChannels.length > 1 && ( <ChannelDropDown  channelData={channelData} handleChannelFilter={handleFilter}/> )}
      </Box>
      <Box>
        <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
          <Table aria-label="simple table">
            <TableHead sx={{ 
                backgroundColor: globalStyles.colors.backgroundPrimary, 
                height: '40px !important',
                borderRadius: '0 !important',
                '& .MuiTableCell-root': {
                  color: '#fff !important',
                  padding: '10px !important',
                  borderRight: '2px solid #fff !important',
                  borderRadius: '0 !important'
                }
              }}>
                <TableRow>
                  {selectedHeaders.map((header) => [
                      <StyledTableCell align='center'>{header.label}</StyledTableCell>
                    ])}
                  <StyledTableCell align='center'>Action</StyledTableCell>
                </TableRow>
            </TableHead>
            <TableBody>
              {listData.map(rma => {
                return (
                  <StyledTableRow> 
                    {selectedHeaders.map((header) => {
                      if (header.id == 'status' && has(globalConfig.rmaStatus, rma['status'])) {
                        return (
                          <StyledTableCell align='center'>
                            <Typography 
                              sx={{
                                fontSize: '14px',
                                backgroundColor: globalConfig.rmaStatus[rma['status']].color,
                                color: '#fff',
                                padding: '4px 8px'
                              }}
                            >
                              {globalConfig.rmaStatus[rma['status']].text}
                            </Typography>
                          </StyledTableCell>
                        )
                      } else {
                        return (
                          <StyledTableCell align='center'>
                            {rma[header.id]}
                          </StyledTableCell>
                        )
                      }
                    })}
                  <StyledTableCell align='center'>
                    <EditIcon sx={{ cursor: 'pointer', color: '#2b3f7a'}} onClick={() => EditReturnHandler(rma)}/>
                  </StyledTableCell>
                  </StyledTableRow>
                )
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <Box sx={{ justifyContent: 'center' }}>
          <Pagination count={Math.ceil(dataCount/50)} page={currentPage} onChange={handlePagination}/>
        </Box>
      </Box>
    </List>
  )
}

export default ReturnsList